// index.js

import { createRouter, createWebHistory } from 'vue-router';
// 导入页面组件
import Login from '../LoginPage.vue';

import NotFound from '../error-tolerance/ErrNotFound.vue';
import ServerError from '../error-tolerance/ErrServerError.vue';
import Prohibited from '../error-tolerance/ErrProhibited.vue';

import DemandHome from '../demand-platform/DemandHome.vue';
import DemandDetail from '../demand-platform/DemandDetail.vue';
import DemandManager from '../demand-platform/DemandManager.vue';

import MeasurementHome from '../measurement-platform/MeasurementHome.vue';
import EmpolyerWhiteList from '@/page/EmpolyerWhiteList.vue';
import DeveloperWhiteList from '@/page/DeveloperWhiteList.vue';


import axios from 'axios';
import Cookies from 'js-cookie';


async function refreshToken() {
  const refreshToken = Cookies.get('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token');
  }

  const response = await axios.get('/user/auth/refreshAccessToken', {
    params: { refreshToken }
  });

  const data = response.data;
  if (data.access_token) {
    if (data.refresh_token) {
      Cookies.set('refreshToken', data.refresh_token, {
        expires: 7,
        secure: false,
        httpOnly: false,
        sameSite: 'Strict',
        path: '/'
      });
    }
    return data.access_token;
  } else {
    throw new Error(data.error_description || 'Refresh failed');
  }
}

const Callback = {
  template: '<div style="padding: 20px; text-align: center;">正在登录中，请稍候...</div>',
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (!code) {
      window.alert('No code found in callback');
      this.$router.push('/login');
      return;
    }

    try {

      const response = await axios.get('/user/auth/getAccessToken', {
        params: { code }
      })

      const data = response.data;

      // console.log(data);

      if (data.access_token && data.refresh_token) {
        Cookies.set('accessToken', data.access_token, {
          expires: 1,
          secure: false,
          httpOnly: false,
          sameSite: 'Strict',
          path: '/'
        })

        Cookies.set('refreshToken', data.refresh_token, {
          expires: 7,
          secure: false,
          httpOnly: false,
          sameSite: 'Strict',
          path: '/'
        })

        localStorage.setItem('token_timestamp', Date.now().toString());

        localStorage.removeItem('oauth_state');

        this.$router.push('/');
      } else {
        window.alert('Login failed: ' + (data.error_description || 'Unknown error'));
        this.$router.push('/login');
      }
    } catch (error) {
      window.alert('Callback error:', error.toString());
      console.error('Callback error:', error);
      this.$router.push('/login');
    }
  }
};


// 路由规则
const routes = [
  // 白名单：无需登录即可访问
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false } // 无需登录
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
    meta: { requiresAuth: false }
  },
  {
    path: '/500',
    name: 'ServerError',
    component: ServerError,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/measurement-platform'
  },
  {
    path: '/403',
    name: 'Prohibited',
    component: Prohibited,
    meta: { requiresAuth: false }
  },
  // 需登录的路由（核心业务页面）
  {
    path: '/demand-platform',
    redirect: '/demand-platform/home/SIX'
  },
  {
    path: '/demand-platform/home',
    redirect: '/demand-platform/home/SIX'
  },
  {
    path: '/demand-platform/home/:version',
    name: 'DemandHome',
    component: DemandHome,
    meta: { requiresAuth: true }
  },
  {
    path: '/demand-platform/detail/:id/:operationCode',
    name: 'DemandDetail',
    component: DemandDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/demand-platform/manager',
    name: 'DemandManager',
    component: DemandManager,
    meta: { requiresAuth: true }
  },
  {
    path: '/auth/callback',
    name: 'Callback',
    component: Callback,
    meta: { requiresAuth: false } // 不需要登录，这是登录入口
  },
  // 重定向：未匹配的路由跳404，未登录时跳登录
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  // OpenHarmony项目群精细化运营平台
  {
    path: '/measurement-platform',
    name: 'MeasurementHome',
    component: MeasurementHome,
    meta: { requiresAuth: true }
  },
  {
    path: '/empolyerWhiteList',
    name: 'EmpolyerWhiteList',
    component: EmpolyerWhiteList,
    meta: { requiresAuth: true }
  },
  {
    path: '/developerWhiteList',
    name: 'DeveloperWhiteList',
    component: DeveloperWhiteList,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  // const token = localStorage.getItem('accessToken');
  const tokenTimestamp = localStorage.getItem('token_timestamp');
  const requiresAuth = to.meta.requiresAuth;

  if (requiresAuth) {
    if (!tokenTimestamp) {
      window.alert('Please log in first.');
      next('/login');
      return;
    }

    const now = Date.now();
    const isWithin8Hours = (now - parseInt(tokenTimestamp)) <= 8 * 60 * 60 * 1000;

    if (isWithin8Hours) {
      next(); // 信任本地时间戳，直接放行
    } else {
      try {
        const newToken = await refreshToken();
        // localStorage.setItem('accessToken', newToken);
        Cookies.set('accessToken', newToken, {
          expires: 1,
          secure: false,
          httpOnly: false,
          sameSite: 'Strict',
          path: '/'
        });
        localStorage.setItem('token_timestamp', Date.now().toString());
        next();
      } catch (error) {
        window.alert('Auth error. Please log in again.');
        console.error('Auth error:', error);
        next('/login');
      }
    }
  } else {
    next();
  }
});

export default router;